$(document).on("click", ".part_ui_select select", function(){
    if ($(this).hasClass("mod--focus")) {
        $(this).off("blur");
    }
    $(this).toggleClass("mod--focus");
    $(this).one("blur",function() {
        $(this).removeClass("mod--focus");
    });
});